import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'
import { PanelType, Product } from 'type/Product'
import { StandWidget } from 'type/tryon'
import { parseIntFinite } from 'util/number'

export type DemoCatalogData = {
  slug: string
  preview?: boolean
  product: Product
  widget: StandWidget
}

export type DemoCatalogParams = {
  boutique: boolean
  basic: boolean
  stand: boolean
  turn: number
  test?: boolean
  start?: boolean
}

export function useDemoParams(panelType?: PanelType): DemoCatalogParams {
  const search = useSearchParams()
  return useMemo<DemoCatalogParams>(() => {
    const boutique = panelType === 'boutique'
    const basic = panelType === 'basic'
    const stand_ = panelType === 'stand'
    const stand = basic || stand_
    const turn = parseIntFinite(search.get('turn')) ?? 0
    const test = search.has('test') && search.get('test') !== 'false' ? true : undefined
    const start = search.has('start') && search.get('start') !== 'false' ? true : undefined
    return { boutique, basic, stand, turn, test, start }
  }, [panelType, search])
}
